export enum COOKIES_KEYS {
    LANG = 'lang'
}

export enum HOME_TAB_KEYS {
    SAFEGUARD_PLAN = 'safeguard_plan',
    INSURANCE_DETAILS = 'insurance_details',
    INFORMATION_FOR_INSURANCE = 'information_for_insurance',
    INFORMATION_DISCLOSURE = 'information_disclosure'
}
